export const primaryColor = '#f9b233';
